/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_UpInputs */

const en_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move a single word up to the previous line`)
};

const fr_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deplacer un mot vers la ligne precedente`)
};

const de_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschiebe ein einzelnes Wort in die vorherige Zeile.`)
};

const it_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta una singola parola alla riga precedente`)
};

const ru_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместитесь на одно слово вверх, на предыдущую строку.`)
};

const es_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mover una sola palabra a la línea anterior`)
};

const zh_cn2_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将一个单词上移到上一行。`)
};

const ja_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つの単語を前の行に移動する`)
};

const hi_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक शब्द को पिछली पंक्ति में ले जाएं`)
};

const pt_pt2_shortcut_keys_desc_move_word_up = /** @type {(inputs: Shortcut_Keys_Desc_Move_Word_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mova uma única palavra para a linha anterior.`)
};

/**
* | output |
* | --- |
* | "Move a single word up to the previous line" |
*
* @param {Shortcut_Keys_Desc_Move_Word_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_up = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "de") return de_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "it") return it_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "es") return es_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_move_word_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_move_word_up(inputs)
	return en_shortcut_keys_desc_move_word_up(inputs)
});